module.exports = __webpack_public_path__ + "static/media/laxmirajmokuf1.5893263b.png";